<template>
    <el-form-item :label="$t.__('companysearch.GB_form.company_name')" prop="search">
        <el-input
            id="search"
            v-model="form.search"
            prop="search"
            :disabled="!providerEnabled"
            class="valign-middle"
            :class="{ 'w-5': inline }"
            :placeholder="$t.__('companysearch.GB_form.enter_company_informations')"
            @keyup.enter="$emit('search-companies')"
        />
    </el-form-item>
</template>
<script>
export default {
    props: {
        providerEnabled: {
            type: Boolean,
            required: true,
            default: true,
        },
        form: {
            type: Object,
            required: true,
            default: () => {},
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>
